@if (gallery()) {
  @if (galleryPermissions().can_edit && !galleryHeaderMode()) {
    <div class="context-top-buttons">
      <button
        appButton
        name="share"
        location="gallery-context-menu"
        [hasIcon]="true"
        spacing="full"
        [verticalIcon]="true"
        height="1"
        color="hard-simple"
        (click)="openShareDialog(); onClose.emit()"
      >
        <app-svg src="/assets/icons/forward.svg"></app-svg>
        <span>Share</span>
      </button>
      <button
        appButton
        name="settings"
        location="gallery-context-menu"
        [hasIcon]="true"
        spacing="full"
        [verticalIcon]="true"
        height="1"
        color="hard-simple"
        (click)="openSettingsDialog(); onClose.emit()"
      >
        <app-svg src="/assets/icons/gear-outline.svg"></app-svg>
        <span>
          <span>Settings</span>
          <app-new-feature-dot [featureName]="'gallery-settings-review'" position="inline"></app-new-feature-dot>
        </span>
      </button>
    </div>
    <div class="divider"></div>
  }
  <div class="button-menu">
    <a
      [href]="previewLink()"
      target="_blank"
      [class.disabled]="
        !previewLink() ||
        gallery().public_access === 'no_access' ||
        (tenant() || activeTenant())['block_public_link_access']
      "
    >
      <app-button-menu-item name="preview" location="gallery-context-menu" [fullWidth]="true" icon="external-link">
        Preview Gallery
      </app-button-menu-item>
    </a>
    <ng-container *onlyForScreens="['mobile', 'tablet']">
      @if (galleryPermissions().can_edit && galleryHeaderMode() && !isPicflowIOSApp) {
        <app-button-menu-item
          name="settings"
          location="gallery-context-menu"
          [fullWidth]="true"
          icon="gear"
          (onClick)="openSettingsDialog(); onClose.emit()"
          data-test-id="gallery-settings"
        >
          <span>Gallery Settings</span>
          <app-new-feature-dot [featureName]="'gallery-settings-review'" position="inline"></app-new-feature-dot>
        </app-button-menu-item>
        @if (!advancedMode()) {
          <app-button-menu-item
            name="theme"
            location="gallery-context-menu"
            [fullWidth]="true"
            imageUrl="/assets/icons/color-spectrum.svg"
            (onClick)="openThemeMenu(); onClose.emit()"
            data-test-id="gallery-settings"
          >
            <span>Gallery Theme</span>
            <app-new-feature-dot [featureName]="'gallery-theme'" position="inline"></app-new-feature-dot>
          </app-button-menu-item>
        }
      }
    </ng-container>
    <div class="divider"></div>
    <app-button-menu-item
      name="gallery-info"
      location="gallery-context-menu"
      [fullWidth]="true"
      data-test-id="gallery-info"
      icon="info-outline"
      (onClick)="onClose.emit(); openGalleryInfoDialog()"
    >
      Gallery Info
    </app-button-menu-item>
    @if (!isPicflowIOSApp) {
      <app-button-menu-item
        name="export"
        location="gallery-context-menu"
        [fullWidth]="true"
        icon="document-text-outline"
        (onClick)="onClose.emit(); openExportDialog()"
      >
        Export (List, CSV, PDF)
      </app-button-menu-item>
    }

    @if (gallery().section) {
      <app-button-menu-item
        name="toggle-visible"
        location="gallery-context-menu"
        [fullWidth]="true"
        data-test-id="toggle-visible"
        [icon]="gallery().public_access === 'no_access' ? 'lock-off' : 'lock'"
        (onClick)="onClose.emit(); toggleSubGalleryHide()"
      >
        @if (gallery().public_access === 'no_access') {
          Make Public
        } @else {
          Make Private
        }
      </app-button-menu-item>
    }

    @if (canDelete() || (galleryPermissions().can_edit && isTeamMember())) {
      <div class="divider"></div>

      @if (galleryPermissions().can_edit && isTeamMember()) {
        <app-button-menu-item
          name="duplicate"
          location="gallery-context-menu"
          [fullWidth]="true"
          icon="copy-outline"
          (onClick)="duplicate(); onClose.emit()"
          data-test-id="duplicate"
        >
          Duplicate
        </app-button-menu-item>

        <app-button-menu-item
          name="move-to"
          location="gallery-context-menu"
          [fullWidth]="true"
          icon="move-out"
          (onClick)="openMoveToDialog(); onClose.emit()"
          data-test-id="move-to-folder"
        >
          Move to (
          <div class="grey-50">...</div>
          )
        </app-button-menu-item>
      }

      <app-button-menu-item
        name="delete"
        location="gallery-context-menu"
        [fullWidth]="true"
        icon="trash"
        color="simple-warn"
        data-test-id="delete-gallery"
        (onClick)="openDeleteGalleryDialog(); onClose.emit()"
      >
        Delete Gallery
      </app-button-menu-item>
    }
  </div>
} @else {
  <div class="loading">
    <app-loading-indicator size="small"></app-loading-indicator>
  </div>
}
